import { useState, useEffect, useRef } from "react";

const SearchableDropdown = ({
  options = [],
  value,
  onChange,
  labelField = "name",
  valueField = "id",
  placeholder = "Select",
  required = false
}) => {
  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const wrapperRef = useRef(null);

  // Set default text when value changes
  useEffect(() => {
    const selected = options.find(opt => opt[valueField] === value);
    setSearch(selected ? (selected[labelField] ?? "") : "");
  }, [value, options, labelField, valueField]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
        setHighlightIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = (options || []).filter(item =>
    item[labelField]?.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (item) => {
    setSearch(item[labelField]);
    onChange(item[valueField]);
    setShowDropdown(false);
    setHighlightIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (!showDropdown) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightIndex(prev =>
        prev < filteredOptions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex(prev =>
        prev > 0 ? prev - 1 : filteredOptions.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightIndex >= 0 && highlightIndex < filteredOptions.length) {
        handleSelect(filteredOptions[highlightIndex]);
      }
    } else if (e.key === "Escape") {
      setShowDropdown(false);
      setHighlightIndex(-1);
    }
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative", width: "100%" }}>
      <input
        className="modify_im_input mode_category1"
        type="text"
        value={search}
        placeholder={placeholder}
        onChange={(e) => {
          setSearch(e.target.value);
          setShowDropdown(true);
          setHighlightIndex(0); // highlight first option initially
        }}
        onFocus={() => {
          setShowDropdown(true);
          setHighlightIndex(0);
        }}
        onKeyDown={handleKeyDown}
        required={required}
      />

      {showDropdown && (
        <div className="dropdown_box">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((item, index) => (
              <div
                key={item[valueField]}
                className={`dropdown_item ${highlightIndex === index ? "highlight" : ""}`}
                onMouseEnter={() => setHighlightIndex(index)}
                onClick={() => handleSelect(item)}
              >
                {item[labelField] ?? "—"}
              </div>
            ))
          ) : (
            <div className="dropdown_item">No data found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;